import { useCallback, useRef, useState, type ReactNode } from 'react';
import type { FeedbackSnackbarProps } from './FeedbackSnackbar';

export type FeedbackSnackbarOptions = Pick<FeedbackSnackbarProps, 'tone' | 'action' | 'autoHideDuration' | 'closeLabel'>;
type Notification = FeedbackSnackbarOptions & { id: number; message: ReactNode };

/** 짧은 결과를 최신 이벤트로 교체합니다. 같은 문구도 새 표시 시간을 갖습니다. */
export function useFeedbackSnackbar() {
  const sequence = useRef(0);
  const [notification, setNotification] = useState<Notification>();
  const notify = useCallback((message: ReactNode, options: FeedbackSnackbarOptions = {}) => {
    setNotification({ ...options, message, id: ++sequence.current });
  }, []);
  const dismiss = useCallback(() => setNotification(undefined), []);
  const id = notification?.id;
  const onClose = useCallback(() => {
    setNotification((current) => current?.id === id ? undefined : current);
  }, [id]);
  const feedbackProps: FeedbackSnackbarProps = {
    open: Boolean(notification),
    message: notification?.message,
    tone: notification?.tone,
    action: notification?.action,
    autoHideDuration: notification?.autoHideDuration,
    closeLabel: notification?.closeLabel,
    notificationKey: id,
    onClose,
  };
  return { notify, dismiss, feedbackProps };
}
